import React from 'react';
import { Image } from '@marvelapp/ui';
export default function CardImage(_a) {
    var locked = _a.locked, src = _a.src, borderRadius = _a.borderRadius;
    return (React.createElement(Image, { borderRadius: borderRadius, disabled: locked, hasTransition: false, margin: "auto", objectFit: "cover", objectPosition: "top", src: src, testId: "card-image" }));
}
